<template>
  <AppHeader />

  <router-view />

  <AppFooter />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { RouteLocationNormalized } from 'vue-router';

  import auditPage from '@/app/admin/api/auditPage';
  import { TVisitPageParams } from '@/app/admin/types/auditPage';
  import AppFooter from '@/app/shared/components/AppFooter.vue';
  import AppHeader from '@/app/shared/components/AppHeader.vue';

  import { getAnonymousUserId } from '@/common/anonymousUserId';

  export default defineComponent({
    name: 'App',
    components: { AppFooter, AppHeader },
    computed: {
      isAuthenticated(): boolean {
        return this.$store.getters['auth/oidc/isAuthenticated'];
      },
    },
    watch: {
      $route: function (to: RouteLocationNormalized, from: RouteLocationNormalized) {
        if (to.matched && to.matched.length > 0 && from.path !== to.path) {
          let request: TVisitPageParams = {
            url: window.location.href,
            isInternal: false,
            routeName: to.matched[0].path,
          };

          const uuid = getAnonymousUserId(this.isAuthenticated);
          if (uuid) {
            request.uuid = uuid;
          }

          auditPage.visitPage(request);
        }
      },
    },
  });
</script>

<style></style>
